import { render } from "./SessionDetailComponentMarch24.vue?vue&type=template&id=82411c6e&scoped=true"
import script from "./SessionDetailComponentMarch24.vue?vue&type=script&lang=js"
export * from "./SessionDetailComponentMarch24.vue?vue&type=script&lang=js"

import "./SessionDetailComponentMarch24.vue?vue&type=style&index=0&id=82411c6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82411c6e"]])

export default __exports__